export default __webpack_public_path__ + "static/media/logo_anim.8adfff0b.gif";